import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { ActionButton } from 'components/ui/Button';
import Select from 'components/ui/Select';
import Input from 'components/ui/Input';

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { MandatoryFieldLabel, ErrorField, Field, StyledSubmitField, StyledForm, StyledOfficeLocation } from './SearchBooking.styles';

const SearchByOnHoldPaymentMonth = ({
  onSubmitSearch,
  isNonEurostarUser,
  defaultMonth,
  defaultOfficeLocation,
  filteredOfficeLocation,
  menuTab
}) => {
  const { register, handleSubmit, formState, setValue } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  const initialDate = moment().startOf('month');
  const months = new Array(12).fill(initialDate).map((date, index) => {
    const month = moment(date).add(index, 'months');
    const label = month.format('MMMM YYYY');
    const value = month.format('YYYY-MM');

    return { label, value };
  });

  const officesLocation = [
    { label: 'All', value: 'ALL' },
    { label: 'EBSC (Ashford)', value: 'EBSC' },
    { label: 'CSC (Brussels)', value: 'CSC' },
    { label: 'Indirect sales', value: 'INDIRECT_SALES' },
    { label: 'Other', value: 'OTHERS' }
  ];

  const [{ value: fallbackValue }] = months;
  const { value: defaultValue } = months.find(({ value }) => (defaultMonth ? value === defaultMonth : value === fallbackValue));

  const [showOthersInput, setShowOthersInput] = useState(defaultOfficeLocation === 'OTHERS');

  const locationChangeHandler = (location) => {
    const othersSelected = location === 'OTHERS';
    setShowOthersInput(othersSelected);
    if (!othersSelected) {
      setValue('filteredOfficeLocation', '');
    }
  };

  return (
    <StyledForm data-testid="search-payment-month-form" onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <MandatoryFieldLabel htmlFor="onHold">
          <FormattedMessage id="searchBooking.onHold" />
        </MandatoryFieldLabel>
        <Select
          {...register('searchPaymentMonth', { required: true })}
          id="searchPaymentMonth"
          data-cy="search-payment-month"
          data-testid="search-payment-month"
          defaultValue={defaultValue}
        >
          {months.map(({ label, value }) => (
            <option key={label} value={value} data-testid={`search-payment-month-${value}`}>
              {label}
            </option>
          ))}
        </Select>
        {!isNonEurostarUser && (
          <>
            <StyledOfficeLocation>
              <FormattedMessage id="bookingDetails.agentOffice" />
              <Select
                {...register('searchOfficeLocation', { required: true })}
                id="searchOfficeLocation"
                data-cy="search-office-location"
                data-testid="search-office-location"
                defaultValue={defaultOfficeLocation || officesLocation[0].value}
                onChange={(e) => locationChangeHandler(e.target.value)}
              >
                {officesLocation.map(({ label, value }) => (
                  <option key={label} value={value} data-testid={`search-office-location-${value}`}>
                    {label}
                  </option>
                ))}
              </Select>
            </StyledOfficeLocation>
            {showOthersInput && !menuTab && (
              <StyledOfficeLocation>
                <FormattedMessage id="bookingDetails.filteredOfficeLocation" />
                <Input
                  {...register('filteredOfficeLocation', {
                    required: false
                  })}
                  id="filteredOfficeLocation"
                  type="text"
                  data-cy="filter-office-location"
                  data-testid="filter-office-location"
                  defaultValue={defaultOfficeLocation === 'OTHERS' ? filteredOfficeLocation : ''}
                ></Input>
              </StyledOfficeLocation>
            )}
          </>
        )}
        {errors.onHold && (
          <ErrorField id="error-on-hold" data-testid="error-on-hold">
            <FormattedMessage id="searchBooking.onHoldValidationMessage" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="on-hold-payments-search" data-testid="on-hold-payments-search" type="submit" disabled={!formState.isValid}>
          <FormattedMessage id="searchBooking.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchByOnHoldPaymentMonth.propTypes = {
  defaultMonth: PropTypes.string,
  onSubmitSearch: PropTypes.func,
  isNonEurostarUser: PropTypes.bool,
  defaultOfficeLocation: PropTypes.string,
  filteredOfficeLocation: PropTypes.string,
  menuTab: PropTypes.bool
};

export default SearchByOnHoldPaymentMonth;
